import { render, staticRenderFns } from "./AlbumAcceuil.vue?vue&type=template&id=5eb61278&scoped=true&"
import script from "./AlbumAcceuil.vue?vue&type=script&lang=js&"
export * from "./AlbumAcceuil.vue?vue&type=script&lang=js&"
import style0 from "./AlbumAcceuil.vue?vue&type=style&index=0&id=5eb61278&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5eb61278",
  null
  
)

export default component.exports